export default {
  promotional_text: 'Spare Zeit & sichere dir Belohnungen!',
  description:
    'Die {{name}} App ist da – für ein noch einfacheres Bestellen:\n\n• Super schnelles Bestellen per App\n\n• Sofortige Benachrichtigungen zu Aktionen und Belohnungen\n\n• Sammle und löse deine Punkte ganz einfach ein\n\n• Verfolge den Status deiner Bestellung in Echtzeit\n\nWir freuen uns, dir unsere App anbieten zu können – und hoffen, du hast genauso viel Spaß damit wie wir!`',
  keywords: 'Mobile Bestellung, Restaurant-App, Essens-App, Abholung, Essen bestellen, Takeaway, Lieferdienst',
};
